import { RouteObject, Navigate } from 'react-router-dom';
import { PagesStudioPage } from './modules/editor';
import { ThemesPage } from './modules/themes';
import { CollectionsPage } from './modules/cms';
import { ErpBlocksPage } from './modules/erp-blocks';
import { FormsPage } from './modules/forms';
import { StorefrontPage } from './modules/storefront';
import { DomainsPage } from './modules/domains';
import { AnalyticsPage } from './modules/analytics';

// webbuilderRoutes declares all 8 suite sub-routes matching WEBBUILDER_MODULES (R-UI-5).
export const webbuilderRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="/webbuilder/pages" replace /> },
  { path: 'pages', element: <PagesStudioPage />, handle: { crumb: 'Pages & Visual Studio' } },
  { path: 'themes', element: <ThemesPage />, handle: { crumb: 'Themes & Brand System' } },
  { path: 'collections', element: <CollectionsPage />, handle: { crumb: 'CMS & Collections' } },
  { path: 'erp-blocks', element: <ErpBlocksPage />, handle: { crumb: 'Live ERP Data Blocks' } },
  { path: 'forms', element: <FormsPage />, handle: { crumb: 'Forms & Conversion Funnels' } },
  { path: 'storefront', element: <StorefrontPage />, handle: { crumb: 'Storefront & Checkout' } },
  { path: 'domains', element: <DomainsPage />, handle: { crumb: 'Domains, TLS & SEO' } },
  { path: 'analytics', element: <AnalyticsPage />, handle: { crumb: 'Web Vitals & Funnel Analytics' } },
];
